import React from 'react';
import { Button } from 'primereact/button';
import { Badge } from 'primereact/badge';

interface ReportData {
    id: number;
    title: string;
    type: string;
    description: string;
    duration: string;
    lastGenerated: string;
}

interface ReportGeneratorProps {
    reports: ReportData[];
}

const ReportGenerator: React.FC<ReportGeneratorProps> = ({ reports }) => {
    const getTypeBadge = (type: string) => {
        const badgeMap = {
            Financial: 'p-badge-success',
            HR: 'p-badge-info',
            Operations: 'p-badge-warning',
            Marketing: 'p-badge-secondary',
        };
        return badgeMap[type as keyof typeof badgeMap] || 'p-badge-secondary';
    };

    const getTypeIcon = (type: string) => {
        const iconMap = {
            Financial: 'ri-money-dollar-circle-line',
            HR: 'ri-team-line',
            Operations: 'ri-settings-line',
            Marketing: 'ri-megaphone-line',
        };
        return iconMap[type as keyof typeof iconMap] || 'ri-file-line';
    };

    return (
        <div className="report-generator-card dashboard-card dashboard-card-wrapper coming-soon-card">
            <div className="card-header d-flex align-items-center justify-content-between mb-3">
                <h5 className="card-title mb-0">
                    <i className="ri-file-chart-line me-2"></i>
                    Report Generator
                </h5>
                <div className="header-actions d-flex align-items-center">
                    <span className="text-muted me-3">Select date range</span>
                    <Button label="All Locations" className="p-button-outlined p-button-sm me-2" />
                    <Button label="PDF Document" className="p-button-outlined p-button-sm me-2" />
                    <Button label="Generate Report" className="p-button-primary p-button-sm" />
                </div>
            </div>

            <div className="reports-grid">
                {reports.map((report) => (
                    <div key={report.id} className="report-item">
                        <div className="report-content">
                            <div className="report-header d-flex align-items-start justify-content-between mb-2">
                                <div className="report-info">
                                    <div className="d-flex align-items-center mb-1">
                                        <i className={`${getTypeIcon(report.type)} me-2`}></i>
                                        <h6 className="report-title mb-0">{report.title}</h6>
                                        <Badge value={report.type} className={`ms-2 ${getTypeBadge(report.type)}`} />
                                    </div>
                                    <p className="report-description text-muted mb-0">{report.description}</p>
                                </div>
                            </div>

                            <div className="report-meta d-flex align-items-center justify-content-between">
                                <div className="report-duration">
                                    <i className="ri-time-line me-1 text-muted"></i>
                                    <span className="text-muted">{report.duration}</span>
                                </div>
                                <div className="report-last-generated text-muted">{report.lastGenerated}</div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ReportGenerator;
